import React from 'react'

export interface ValidationErrorDisplayProps {
  message: string
  id?: string
  /** Extra classes appended to the message text only (e.g. a smaller font for a long message in a narrow field). Leaves every other usage's default size untouched. */
  messageClassName?: string
}

export const ValidationErrorDisplay: React.FC<ValidationErrorDisplayProps> = ({ message, id, messageClassName }) => (
  <div className="error-description">
    <ul id={id} className="m-0 p-0 list-none">
      <li className="flex items-start! gap-1 mt-1">
        <img src="/assets/images/errorCircleSmall.svg" alt="" width={16} height={16} className="w-4 h-4 shrink-0 mr[0px]! mt-[3px]!" />
        <span className="screenreader-only">Error</span>
        <span className={messageClassName ? `text-red-600 text-sm ${messageClassName}` : 'text-red-600 text-sm'}>{message}</span>
      </li>
    </ul>
  </div>
)

export default ValidationErrorDisplay
